// extracted by mini-css-extract-plugin
export default {"wrap":"Input_wrap__11OsP","wrap__label":"Input_wrap__label__sTz4D","wrap__input":"Input_wrap__input__bXxvN","wrap__error":"Input_wrap__error__otiHU"};